import Vue from 'vue'
import axios from 'axios'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import Utils from './common/utils'
import 'element-ui/lib/theme-chalk/reset.css'
import 'element-ui/lib/theme-chalk/index.css'
import './mock.js'

import 'babel-polyfill'

// 将自动注册所有组件为全局组件
import dataV from '@jiaminghi/data-view'

Vue.use(dataV)


// 适配flex
import '@/common/flexible.js';

//引入echart
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

/*高德地图*/
import VueAMap from 'vue-amap';
import '@vuemap/vue-amap/dist/style.css'
// VueAMap.initAMapApiLoader({
//   // 高德的key
//   key: '26e9f332f69167d238decb0db997e1df',
//   // 插件集合
//   plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.DistrictLayer', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
//   // 高德 sdk 版本，默认为 1.4.4
//   v: '1.4.4',
//  });
//  Vue.use(VueAMap);



// localStorage.setItem("unitCode",'0');
// localStorage.setItem("unitName",'中国产权交易信息网');



// localStorage.setItem("unitCode",'410825000000');
// localStorage.setItem("unitName",'温县');
// localStorage.setItem("indexMap",'http://36.133.43.44:8933/property-assets/map/map_wenxian.png');


// localStorage.setItem("unitCode",'410800000000');
// localStorage.setItem("unitName",'焦作市');
// localStorage.setItem("indexMap",'http://36.133.43.44:8933/property-assets/map/map_jiaozuo.png');

// localStorage.setItem("unitCode",'411000000000');
// localStorage.setItem("unitName",'许昌市');
// localStorage.setItem("indexMap",'http://36.133.43.44:8933/property-assets/map/map_xuchang.png');

// localStorage.setItem("unitCode",'410200000000');
// localStorage.setItem("unitName",'开封市');
// localStorage.setItem("indexMap",'http://36.133.43.44:8933/property-assets/map/map_kaifeng.png');

// localStorage.setItem("unitCode",'410225000000');
// localStorage.setItem("unitName",'兰考县');
// localStorage.setItem("indexMap",'http://36.133.43.44:8933/property-assets/map/map_lankao.png');
// localStorage.setItem("contact_phone",'037126168089、15537835577');
// localStorage.setItem("contact_address",'兰考县兰曹路北侧金融小镇（新时代购物广场对面)');




localStorage.setItem("unitCode",'411500000000');
localStorage.setItem("unitName",'信阳市');
localStorage.setItem("indexMap",'http://36.133.43.44:8933/property-assets/map/map_xinyang.png');
localStorage.setItem("location",'114.091058,32.148624');


// localStorage.setItem("unitCode",'411523000000');
// localStorage.setItem("unitName",'新县');
// localStorage.setItem("indexMap",'http://36.133.43.44:8933/property-assets/map/map_xinxian.png');


// localStorage.setItem("unitCode",'411521000000');
// localStorage.setItem("unitName",'罗山县');
// localStorage.setItem("indexMap",'http://36.133.43.44:8933/property-assets/map/map_luoshan.png');


// localStorage.setItem("unitCode",'411522000000');
// localStorage.setItem("unitName",'光山县');
// localStorage.setItem("indexMap",'http://36.133.43.44:8933/property-assets/map/map_guangshan.png');



// localStorage.setItem("unitCode",'411524000000');
// localStorage.setItem("unitName",'商城县');
// localStorage.setItem("indexMap",'http://36.133.43.44:8933/property-assets/map/map_shangcheng.png');


// localStorage.setItem("unitCode",'411525000000');
// localStorage.setItem("unitName",'固始县');
// localStorage.setItem("indexMap",'http://36.133.43.44:8933/property-assets/map/map_gushi.png');



// localStorage.setItem("unitCode",'411526000000');
// localStorage.setItem("unitName",'潢川县');
// localStorage.setItem("indexMap",'http://36.133.43.44:8933/property-assets/map/map_huangchuan.png');


// localStorage.setItem("unitCode",'411527000000');
// localStorage.setItem("unitName",'淮滨县');
// localStorage.setItem("indexMap",'http://36.133.43.44:8933/property-assets/map/map_huabin.png');


// localStorage.setItem("unitCode",'411528000000');
// localStorage.setItem("unitName",'息县');
// localStorage.setItem("indexMap",'http://36.133.43.44:8933/property-assets/map/map_xixian.png');


Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.prototype.Utils = Utils;
//axios.defaults.baseURL = 'http://127.0.0.1:8547/api/' 
axios.defaults.baseURL = 'http://36.133.43.44:8547/api/'
axios.interceptors.request.use(config => {
	config.headers['token'] =localStorage.getItem('token')
	return config
})

/* 处理响应拦截器 */
// 响应 拦截器 的第二个参数, err 可以捕获状态, 来进行响应的处理
axios.interceptors.response.use(response => {
		if (response.status === 200) {
			const res = response;
   //    console.log(res.data)
			/* 如果 code 是-1 说明用户注销 或者 或者token已经过期了 */
			/* 需要消除localStoreage 和 清除vuex的token */
			if (res.data.code === 101) {
				localStorage.setItem('token',"");

				router.push("/login");
				return;
			}
      if(res.data.code==105){
         router.push("/login");
          	return;
      }
		}
		return response;
	},
	err => {
		/*判断一下未授权 */
		if (err.response.status === 401) {
			clearHandler();
		}
	});
  Vue.prototype.$http = axios



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
